import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { AUDIT_TRAIL_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetAuditTrailByIdProps {
  communityId: string;
  jeMasterId: string;
  ujeAuditId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getAuditTrailById = async (communityId: string, jeMasterId: string, ujeAuditId: string) =>
  await axiosAuth.get(`${AUDIT_TRAIL_API(communityId)}/${jeMasterId}/stage/${ujeAuditId}`);

const useGetAuditTrailById = ({
  communityId,
  jeMasterId,
  ujeAuditId,
  queryParams,
}: UseGetAuditTrailByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["audit-trail-by-id", jeMasterId, ujeAuditId],
    queryFn: () => getAuditTrailById(communityId, jeMasterId, ujeAuditId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetAuditTrailById;
